import { useCurrentBot } from '../model'
import styles from './Bot.module.css'

/**
 * Плашка над формами настройки: чьи настройки сейчас правятся.
 *
 * Без неё легко поправить анкету «не того» бота: страницы у всех ботов
 * одинаковые, а переключатель остаётся в сайдбаре, вне поля зрения.
 */
export function BotBanner() {
  const { isMain, name } = useCurrentBot()
  return (
    <div className={`${styles.banner} ${isMain ? '' : styles.bannerAlt}`} role="status">
      {isMain ? (
        <>
          Вы правите <b>основного бота</b> — им идут тестовые звонки и запуски, где бот не выбран.
        </>
      ) : (
        <>
          Вы правите бота <b>«{name}»</b>. Основной бот не меняется. Голос, часы работы и
          номер у ботов общие.
        </>
      )}
    </div>
  )
}
